import { render, staticRenderFns } from "./check.view.vue?vue&type=template&id=08bee1f6&"
import script from "./check.view.ts?vue&type=script&lang=ts&"
export * from "./check.view.ts?vue&type=script&lang=ts&"
import style0 from "./check.view.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports